import React, { FC, useMemo } from 'react';
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { formatPrice } from '../../../selectors';
import { AbilityModel } from '../../../models/AbilityModel';
import { HeaderModel } from '../../../models/CommonModel';
import SortableColumn from '../../../components/Table/SortableColumn';
import { ConsignSupplierModel } from '../../../modules/auth/models/ConsignmentsModel';
import { Badge } from 'react-bootstrap-v5';

type Props = {
    data: Array<ConsignSupplierModel>
    header: HeaderModel[],
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void,
    hideConfig?: boolean
    selected: number[]
    setSelected: (ids: number[]) => void
};

const ConsignmentSupplierTable: FC<Props> = ({ 
    data, header, hideCols, openColConfig, handleSort, hideConfig, 
    selected, setSelected
}) => {
    const intl = useIntl();
    const toggleSelected = (item: ConsignSupplierModel, checked: boolean) => {
        if (checked && item.id && !selected.includes(item.id)) {
            selected.push(item.id)
            setSelected([...selected])
            return;
        }

        if (!checked && item.id && selected.includes(item.id)) {
            let newSelected = selected.filter((id) => id !== item.id)
            setSelected(newSelected)
        }
    }
    return (
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th></th>
                        {!hideConfig && (
                            <th>
                                <i
                                    className="fa fa-cogs"
                                    style={{ cursor: 'pointer' }}
                                    onClick={openColConfig}
                                ></i>
                            </th>
                        )}
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                        <th>Trạng thái</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: ConsignSupplierModel, index: number) => {
                        const checked  = (!!item.id && selected.includes(item.id));
                        return (
                            <tr key={`ability_${index}`} className="cursor-pointer">
                                {!hideConfig && (
                                <td></td>
                                )}
                                <td>
									<input
										className="form-check-input"
										type="checkbox"
                                        disabled={item.is_connected === 1}
										checked={checked}
										onChange={(e) => toggleSelected(item, e.target.checked)}
									/>
								</td>
                                {!hideCols.includes('name') && (
                                <td>{item.name}</td>
                                )}
                                {!hideCols.includes('contact_info') && (
                                <td>
                                    Địa chỉ: {item.address ?? '--'}<br/>
                                    Điện thoại: {item.phone ?? '--'}<br/>
                                    Email: {item.email ?? '--'}<br/>
                                </td>
                                )}
                                {!hideCols.includes('tax_code') && (
                                <td>
                                    <td>{item.tax_code ?? ''}</td>
                                </td>
                                )}
                                <td>
                                    {item.is_connected === 1 ? (
                                        <Badge className='bg-success'>Đã kết nối</Badge>
                                    ) : (
                                        <Badge className='bg-warning'>Chưa kết nối</Badge>
                                    )}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default ConsignmentSupplierTable;